
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/pages/utils/components/newWorkspaceContentHeader.scss.css.virtualfile';
        module.exports = {"root":"_root_9a091_8","addPage":"_addPage_9a091_16"};